/*
 *
 * custom components
 *
 * start
 *
 */

import ConsoleService from './consoleServiceModules/ConsoleService';

import ConsoleServiceIndexedDbModuleRecipientComponent from "./consoleServiceModules/ConsoleServiceIndexedDbModuleRecipientComponent";

import { indexed_db_name, indexed_db_version } from './../IndexedDbComponent';

/*
 *
 * custom components
 *
 * stop
 *
 */

const execute = (payload) => {

    let flag_console_log = ConsoleServiceIndexedDbModuleRecipientComponent;

    ConsoleService('', flag_console_log);
    ConsoleService('IndexedDbRecipientCreateComponent', flag_console_log);

    ConsoleService('IndexedDbRecipientCreateComponent / payload', flag_console_log);
    ConsoleService(payload, flag_console_log);

    let idb_name = indexed_db_name;

    ConsoleService('IndexedDbRecipientCreateComponent / IndexedDb / idb name', flag_console_log);
    ConsoleService(idb_name, flag_console_log);

    let version = indexed_db_version;

    ConsoleService('IndexedDbRecipientCreateComponent / IndexedDb / version', flag_console_log);
    ConsoleService(version, flag_console_log);

    return new Promise(
        (resolve, reject) => {

            ConsoleService('IndexedDbRecipientCreateComponent / new promise', flag_console_log);

            let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

            /*
             *
             * request
             *
             * start
             * 
             */

            let request = indexedDB.open(idb_name, version);

            /*
             * request / on success / callback
             *
             * start
             * 
             */

            request.onsuccess = function (event) {

                ConsoleService('IndexedDbRecipientCreateComponent / request / on success', flag_console_log);

                ConsoleService('IndexedDbRecipientCreateComponent / request / on success / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                let db = event.target.result;

                /*
                 *
                 * transaction
                 *
                 * start
                 * 
                 */

                /*
                 *
                 * transaction
                 * 
                 * open a read/write db transaction, ready for adding the data
                 * 
                 * https://developer.mozilla.org/en-US/docs/Web/API/IDBDatabase/transaction
                 * 
                 */

                let transaction = db.transaction(['recipient_object_store'], 'readwrite');

                ConsoleService('IndexedDbRecipientCreateComponent / request / on success / transaction', flag_console_log);
                ConsoleService(transaction, flag_console_log);

                /*
                 * report on the success of opening the transaction
                 */

                transaction.oncomplete = function (event) {

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / transaction / on complete', flag_console_log);

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / transaction / on complete / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    // !! SHOULD THE "RESOLVE" EVENT BE HERE ? !!

                    //resolve(event);

                }

                transaction.onerror = function (event) {

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / transaction / on error', flag_console_log);

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / transaction / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * transaction
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store
                 *
                 * start
                 * 
                 */

                let objectStore = transaction.objectStore('recipient_object_store');

                ConsoleService('IndexedDbRecipientCreateComponent / objectStore', flag_console_log);
                ConsoleService(objectStore, flag_console_log);

                ConsoleService('IndexedDbRecipientCreateComponent / objectStore.indexNames', flag_console_log);
                ConsoleService(objectStore.indexNames, flag_console_log);

                ConsoleService('IndexedDbRecipientCreateComponent / objectStore.keyPath', flag_console_log);
                ConsoleService(objectStore.keyPath, flag_console_log);

                ConsoleService('IndexedDbRecipientCreateComponent / objectStore.name', flag_console_log);
                ConsoleService(objectStore.name, flag_console_log);

                ConsoleService('IndexedDbRecipientCreateComponent / objectStore.transaction', flag_console_log);
                ConsoleService(objectStore.transaction, flag_console_log);

                ConsoleService('IndexedDbRecipientCreateComponent / objectStore.autoIncrement', flag_console_log);
                ConsoleService(objectStore.autoIncrement, flag_console_log);

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * start
                 * 
                 */

                /*
                * we need to save the data
                * a new reacipient will be created
                */

                let objectStoreRequest = objectStore.add(payload);

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onsuccess = function (event) {

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / object store request / on success', flag_console_log);

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / object store request / on success / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    // !! SHOULD THE "RESOLVE" EVENT BE HERE ? !!

                    resolve(event);

                }

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onerror = function (event) {

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / object store request / on error', flag_console_log);

                    ConsoleService('IndexedDbRecipientCreateComponent / request / on success / object store request / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * stop
                 * 
                 */

            };

            /*
             * request / on success / callback
             *
             * stop
             * 
             */

            /*
             * request / on error / callback
             *
             * start
             * 
             */

            request.onerror = function (event) {

                ConsoleService('IndexedDbRecipientCreateComponent / request / on error', flag_console_log);

                ConsoleService('IndexedDbRecipientCreateComponent / request / on error / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                reject(event);

            };

            /*
             * request / on error / callback
             *
             * stop
             * 
             */

            /*
             *
             * request
             *
             * start
             * 
             */

        }
    ).then(
        (data) => {

            /*
            *
            * ok
            *
            */

            ConsoleService('IndexedDbRecipientCreateComponent / new promise => then', flag_console_log);

            ConsoleService('IndexedDbRecipientCreateComponent / new promise => then / data', flag_console_log);
            ConsoleService(data, flag_console_log);

            return data;

        }
    ).catch(
        (data) => {

            /*
            *
            * error
            *
            */

            ConsoleService('IndexedDbRecipientCreateComponent / new promise => catch', flag_console_log);

            ConsoleService('IndexedDbRecipientCreateComponent / new promise => catch / data', flag_console_log);
            ConsoleService(data, flag_console_log);

            return data;

        }
    );

}

export default execute;